import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] grid place-items-center px-6" data-testid="not-found-page">
      <div className="text-center">
        <div className="font-mono text-xs text-brand">404</div>
        <h1 className="font-display tracking-tighter text-5xl mt-3">Page not found</h1>
        <p className="text-slate-400 mt-3">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" className="inline-block mt-6">
          <Button className="btn-glow rounded-full h-11 px-6" data-testid="not-found-home">Back home</Button>
        </Link>
      </div>
    </div>
  );
}
